import React from 'react';

import type { TagEntity } from '@schibsted/frapi-schema';

import { filterTagsOnType, makeTagTitle } from '../../articles/helpers.js';
import { sectionTitleMappings } from '../../../layouts/front/sectionHelpers.js';

const TeaserTag: React.FC<{ tags: TagEntity[]; section: string }> = ({
  tags,
  section,
}) => {
  const typeTags = filterTagsOnType(tags, ['kjøkken', 'format', 'tema'], 1);

  return (
    <div className="bottom-tags">
      {typeTags.length > 0
        ? makeTagTitle(typeTags[0].title)
        : sectionTitleMappings(section)}
    </div>
  );
};
export default TeaserTag;
